import axios from 'axios';

export const retrieveMineData = async () => {
    console.log(localStorage.getItem("jwt"));
    const mineResponse = await axios.get('https://adapt-api.softmining.it/mines/me', {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });
    console.log('MINA');
    console.log(mineResponse);
    const mine = mineResponse.data;
    if (!mine || !mine.data) {
        throw new Error('Must be part of a mine!');
    }
    return mine.data;
};

export const consumeToken = async (tokensToConsume) => {
    await axios.post(
        `https://adapt-api.softmining.it/mines/me/tokens`,
        { tokens: tokensToConsume },
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }
    );
};
